import { render } from "./ProfileBloc.vue?vue&type=template&id=663bef80"
import script from "./ProfileBloc.vue?vue&type=script&lang=js"
export * from "./ProfileBloc.vue?vue&type=script&lang=js"
script.render = render

export default script